import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ResourcesService } from '../services/resources.service';

export const resourceTypeGuard: CanActivateFn = (route) => {

  const resourcesService = inject(ResourcesService);
  const router = inject(Router);

  const type = route.paramMap.get('type');

  if (!type) {
    return router.parseUrl('/not-found');
  }

  return resourcesService.isValidType(type)
    ? true
    : router.parseUrl('/not-found');

};